import React from 'react';
import styled from 'styled-components/macro';
import { device } from '../../../Theme';

export const HeroCategory = ({ category }) => {
  return (
    <UL>
      {category.map((category) => (
        <LI key={category}>
          <Category>{category}</Category>
        </LI>
      ))}
    </UL>
  );
};

const UL = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  list-style: none;
`;

const LI = styled.li`
  position: relative;
  + li {
    margin-left: 28px;
  }
  + li:before {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -18px;
    display: flex;
    width: 8px;
    height: 8px;
    background: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black50
        : props.theme.color.white50};
    border-radius: 50px;
    content: '';
  }
`;

const Category = styled.p`
  ${(props) => props.theme.fontBook};
  ${(props) => props.theme.font.subtitle2.book};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  @media ${device.tablet} {
    ${(props) => props.theme.font.subtitle.book};
  }
`;
